/* eslint-disable ember/no-computed-properties-in-native-classes, warp-drive/no-legacy-request-patterns */
import Fragment from 'ember-data-model-fragments/fragment';
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';
import type StoreService from '@linc-technologies/linced-common/services/store';
import type Person from '@linc-technologies/linced-common/models/person';
import type Group from '@linc-technologies/linced-common/models/group';

// Proto: bookings.TeacherGroupMapping.
export default class TeacherGroupMapping extends Fragment {
  declare [Type]: 'bookings/teacher-group-mapping';

  // Services
  @service()
  declare store: StoreService;

  // teacherIds is the list of teachers associated with the mapping.
  @array('string')
  declare teacherIds: StatefulArray<string>;

  @computed('teacherIds.[]')
  get teachers() {
    if (isEmpty(this.teacherIds)) {
      return [];
    }
    // Loaded records are saved, so each has an id.
    return (
      this.store.peekAll('person') as unknown as (Person & { id: string })[]
    ).filter((teacher) => {
      return this.teacherIds.includes(teacher.id);
    });
  }

  // groupIds is the list of groups associated with the mapping.
  @array('string')
  declare groupIds: StatefulArray<string>;

  @computed('groupIds.[]')
  get groups() {
    if (isEmpty(this.groupIds)) {
      return [];
    }
    // Loaded records are saved, so each has an id.
    return (
      this.store.peekAll('group') as unknown as (Group & { id: string })[]
    ).filter((group) => {
      return this.groupIds.includes(group.id);
    });
  }

  @alias('teachers.length')
  declare teacherCount: unknown;

  @alias('groups.length')
  declare groupCount: unknown;

  // maxBookings is maximum number of bookings that can be made for this allocation.
  @attr('number', { defaultValue: 0 })
  declare maxBookings: number;
}
